import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * PageTransition - Wrapper component for smooth page transitions
 * Uses CSS animations defined in index.css
 * Key prop forces re-mount and animation restart on route change
 */
const PageTransition = ({ children }) => {
  const location = useLocation();
  
  return (
    <div className="page-transition" key={location.pathname}>
      {children}
    </div>
  );
};

export default PageTransition;
